import React, { Component } from 'react';
// import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';

class NavBar extends Component {
	render() {
		// const { classes } = this.props;
		// console.log(this.props);
		return (
			<>
			<AppBar title="ImageZ" position="static" color="secondary">
				<Toolbar variant="dense">
					
					<IconButton edge="start" color="inherit" aria-label="menu">
						<MenuIcon />
					</IconButton>
					<Typography variant="h6" color="inherit">
						ImageZ
					</Typography>
					
				</Toolbar>
			</AppBar>
			</>
		);
	}
}

export default NavBar;